import { Route } from '@angular/router';

export const FloorPlanRoutes: Route[] = [
  {
    path: 'floor-plan',
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/floor-plan/floor-plan.page'),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../pages/floor-plan/floor-plan-detail/floor-plan-detail.page'),
      },
    ],
  },
];
